var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.cellValue,"id":_vm.ctrlId,"prefix":"$","single-line":"","readonly":"","height":"24"}})
}
var staticRenderFns = []

export { render, staticRenderFns }